import http from '../http'
const API_URL = "notification"

class notificationAPI {

  async save(companyID, userID, messageID, itemID) {
    const response = await http(`${API_URL}/save`, 'POST', {
      viewed: 0,
      companies_id: companyID,
      user_sst_id: userID,
      message_id: messageID,
      items_id: itemID
    })
    return response || null
  }

  async getAllNotifications(companyID, page) {
    const response = await http(`${API_URL}/company/${companyID}?page=${page}`)
    return response || null
  } 

  async getByUser(companyID, userID, page) {
    const response = await http(`${API_URL}/user/paginate/${userID}?page=${page}`, 'POST', {
      companies_id: companyID
    })
    return response
  }
  
  async update(id, notification) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', notification)
    return response
  }

  async unread(companyID) {
    const response = await http(`${API_URL}/active/companies/${companyID}`)
    return response
  }
  
  async unreadByUser(companyID, userID) {
    const response = await http(`${API_URL}/active/user/${userID}`, 'POST', {
      companies_id: companyID
    })
    return response
  }

}

export default new notificationAPI()